import * as basicScroll from 'basicscroll';

const textElements = [...document.querySelectorAll('.transform-text-wrapper')];

const basicScrollElements = textElements?.map((textEl) => {
  const transformTextEl = textEl.querySelector('.transform-text');
  const endValue = transformTextEl.dataset.txEnd || '20%';

  return basicScroll.create({
    elem: textEl.querySelector('.anchor'),
    from: 'top-bottom',
    to: 'bottom-top',
    direct: transformTextEl,
    track: false,
    props: {
      '--tx': {
        from: '0',
        to: endValue,
      },
    },
  });
});

const initScrollElements = () =>
  basicScrollElements.forEach((el) => el.start());

export const updateScrollElements = () =>
  basicScrollElements.forEach((el) => {
    el.calculate();
    el.update();
  });

document.addEventListener('DOMContentLoaded', () => initScrollElements());
window.addEventListener('resize', updateScrollElements);
